import React, { useState } from 'react';
import { Maximize2, Filter } from 'lucide-react';
import { portfolioImages } from '../data';

export default function Portfolio({ onImageClick }) {
  const [activeFilter, setActiveFilter] = useState('Alle');

  const categories = [
    'Alle',
    'Sokkel',
    'Terrændæk',
    'Belægning',
    'Støttemur',
    'Gravearbejde',
    'Nedbrydning'
  ];

  const filteredImages = activeFilter === 'Alle'
    ? portfolioImages
    : portfolioImages.filter(img => img.category === activeFilter);

  const displayedImages = filteredImages.slice(0, 4);

  return (
    <section id="billeder" className="w-full bg-slate-50 py-20 px-4 sm:px-6 lg:px-8 border-t border-b border-slate-200">
      <div className="max-w-7xl mx-auto">
        
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 uppercase tracking-tight mt-2">
            Billeder af udført arbejde
          </h2>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveFilter(category)}
              className={`px-5 py-2.5 text-xs font-bold uppercase tracking-wider rounded-none transition-all cursor-pointer ${
                activeFilter === category
                  ? 'bg-sky-500 text-white shadow-md'
                  : 'bg-white text-slate-700 hover:bg-slate-100 border border-slate-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Project Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {displayedImages.map((image, index) => (
            <div
              key={index}
              onClick={() => onImageClick(portfolioImages.indexOf(image))}
              className="group relative aspect-[3/4] bg-slate-200 overflow-hidden cursor-pointer border border-slate-200 shadow-sm hover:shadow-md transition-all duration-300"
            >
              {/* Image */}
              <img
                src={image.url}
                alt={image.alt || 'Udført arbejde'}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              
              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <span className="bg-sky-500 text-white p-3 shadow-lg">
                  <Maximize2 className="w-5 h-5" />
                </span>
              </div>
            </div>
          ))}
        </div>

        {filteredImages.length === 0 && (
          <div className="text-center py-12 text-slate-500 font-medium">
            Ingen billeder fundet i denne kategori.
          </div>
        )}

      </div>
    </section>
  );
}
